module.exports = __webpack_public_path__ + "5d0be3e3610d5100008891f6b498679d.MP3";